import React from 'react';
import Typography from '@mui/material/Typography';
import { Flex } from '../Flex';
import { fontSize } from '../../style/utils';
import ChipList, { Props as ChipListProps } from './ChipList';

const TagsChipListItem = ({ value }: { value: string }) => (
  <Flex sx={{ gap: 1, alignItems: 'center' }}>
    <Typography
      sx={{ fontSize: fontSize('sm'), color: 'content.secondary' }}
    >{`#${value}`}</Typography>
  </Flex>
);

const TagsChipList = React.forwardRef((props: ChipListProps, ref: any) => (
  <ChipList
    ref={ref}
    {...props}
    renderer={(val) => <TagsChipListItem value={val} />}
    optionRenderer={(val) => <TagsChipListItem value={val} />}
  />
));

export default TagsChipList;
